module.exports = "/_next/static/images/careersPhoto-85abb74b46d222d15c3f36e1f233366e.jpg.webp";